export const JSON_URL = process.env.GATSBY_WORDPRESS_URL
export const GOOGLE_MAPS_KEY = process.env.GATSBY_GOOGLE_MAPS_KEY